module.exports = __webpack_public_path__ + "static/media/avatar3.609374d0.jpeg";